import {
  CLEAR,
  STATUS,
  TOKEN,
  USERNAME,
  LINE_GRAPH,
  GRAPH_LABEL,
} from "./types";

const initialState = {
  username: "",
  token: null,
  status: "",
  graphSets: [],
  graphLabel: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case USERNAME:
      return { ...state, username: action.payload };

    case TOKEN:
      return { ...state, token: action.payload };

    case STATUS:
      return { ...state, status: action.payload };

    case LINE_GRAPH:
      return { ...state, graphSets: [...state.graphSets, ...action.payload] };

    case GRAPH_LABEL:
      return { ...state, graphLabel: [...state.graphLabel, ...action.payload] };

    case CLEAR: {
      return initialState;
    }
    default:
      return state;
  }
};
export default reducer;
